import {
  GET_USER,
  GET_USERS,
  GET_USER_CLIENTS,
  GET_USER_DETAILS,
  GET_USER_LIST,
  GET_USER_ROLES_V2,
  GET_USER_ASSIGNED_CLIENTS,
  USER_LOGOUT,
  GET_USER_NOTIFICATIONS,
  MARK_NOTIFICATIONS_AS_READ,
  SET_SELECTED_NOTIFICATION_COMMENT,
  RESET_SELECTED_NOTIFICATION_COMMENT,
  GET_UNREAD_NOTIFICATION_COUNT,
  RESET_NOTIFICATIONS,
  GET_USER_SETTINGS,
  UPDATE_USER_SETTINGS,
  GET_USER_DEFAULT_SETTINGS,
  GET_NOTIFICATION_BY_ID,
  GET_EXCLUDE_PRE_TRANSACTION,
  SET_TRANSACTION_FILTER_OVERRIDE,
  RESET_TRANSACTION_FILTER_OVERRIDE,
} from "../actions/actionTypes";

const initialState = {
  details: {
    userEmailAddress: null,
  },
  clients: [],
  userRoles: [],
  users: [],
  usersList: [],
  userClients: [],
  userDetails: {},
  notifications: [],
  selectedNotification: null,
  unReadNotification: {},
  userSettings : {},
  defaultUserSettings : {},
  excludePreTransaction: null,
  transactionFilterOverride: null,
  // Bumped on every RESET_TRANSACTION_FILTER_OVERRIDE dispatch (even if the override was
  // already null), so consumers can detect "a nav-link reset just happened" as a discrete
  // event rather than inferring it from transactionFilterOverride's before/after value.
  transactionFilterResetTick: 0,
};

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case GET_USER: {
      const { data } = action.payload ?? {
        userFirstName: userClaim?.sub.toLowerCase().split("@")[0],
        userLastName: userClaim?.sub.toLowerCase().split("@")[1],
      };
      const userClaim = JSON.parse(localStorage.getItem("okta-token-storage"))
        .accessToken?.claims;
      return {
        ...state,
        details: {
          ...data,
          adGuid: userClaim?.ADGUID,
          userEmailAddress: userClaim?.sub.toLowerCase(),
        },
      };
    }

    case GET_USER_DETAILS: {
      const { data } = action.payload;

      return {
        ...state,
        userDetails: data,
      };
    }

    case GET_USER_CLIENTS: {
      const { data } = action.payload;

      return {
        ...state,
        clients: data,
      };
    }

    case GET_USER_ROLES_V2: {
      const { data } = action.payload;

      return {
        ...state,
        userRoles: data,
      };
    }

    case GET_USERS: {
      const { data } = action.payload;

      return {
        ...state,
        users: data,
      };
    }

    case GET_USER_LIST: {
      const { data } = action.payload;

      return {
        ...state,
        usersList: data,
      };
    }

    case GET_USER_ASSIGNED_CLIENTS: {
      const { data } = action.payload;

      return {
        ...state,
        userClients: data,
      };
    }

    case USER_LOGOUT: {
      return initialState;
    }

    case GET_USER_NOTIFICATIONS: {
      const { data } = action.payload;
      let newUniqueNotifications = [];
      const existingIds = new Set(
        state.notifications.map((notification) => notification.id)
      );
      newUniqueNotifications = data.filter(
        (notification) => !existingIds.has(notification.id)
      );

      return {
        ...state,
        notifications: [...state.notifications, ...newUniqueNotifications],
      };
    }

    case MARK_NOTIFICATIONS_AS_READ: {
      const { notificationId } = action.payload;
      let copy = [];
      let updatedNotifications = [];
      if (state.notifications) {
        copy = [...state.notifications];
      }
      if (notificationId)
        updatedNotifications = copy.map((notification) =>
          notification.id === notificationId
            ? { ...notification, isRead: true }
            : notification
        );
      else
        updatedNotifications = copy.map((notification) => ({
          ...notification,
          isRead: true,
        }));
      return {
        ...state,
        notifications: updatedNotifications,
      };
    }

    case GET_UNREAD_NOTIFICATION_COUNT: {
      const { data } = action.payload;

      return {
        ...state,
        unReadNotification: data,
      };
    }

    case SET_SELECTED_NOTIFICATION_COMMENT: {
      const { notification } = action.payload;

      return {
        ...state,
        selectedNotification: notification,
      };
    }

    case RESET_SELECTED_NOTIFICATION_COMMENT: {
      const { notification } = action.payload;

      return {
        ...state,
        selectedNotification: notification,
      };
    }

    case RESET_NOTIFICATIONS: {
      const { notification } = action.payload;

      return {
        ...state,
        notifications: notification,
      };
    }

    case GET_USER_SETTINGS: {
      const { data } = action.payload;

      return {
        ...state,
        userSettings: data,
      };
    }

    case UPDATE_USER_SETTINGS: {
      const { data } = action.payload;

      return {
        ...state,
        userSettings: data,
      };
    }

    case GET_USER_DEFAULT_SETTINGS: {
      const { data } = action.payload;

      return {
        ...state,
        defaultUserSettings: data,
      };
    }

    case GET_NOTIFICATION_BY_ID: {
      const { data } = action.payload;

      return {
        ...state,
        selectedNotification: data,
      };
    }

    case GET_EXCLUDE_PRE_TRANSACTION: {
      const { data } = action.payload;

      return {
        ...state,
        excludePreTransaction: data,
      };
    }

    case SET_TRANSACTION_FILTER_OVERRIDE: {
      const { filterOverride } = action.payload;

      return {
        ...state,
        transactionFilterOverride: filterOverride,
      };
    }

    case RESET_TRANSACTION_FILTER_OVERRIDE: {
      return {
        ...state,
        transactionFilterOverride: null,
        transactionFilterResetTick: state.transactionFilterResetTick + 1,
      };
    }

    default:
      return state;
  }
}
